import type * as React from 'react';

import type { TestimonialItem } from '@coursera-web/cds-labs';

import type { PromoTemplateTestimonialCarouselFragment } from 'bundles/front-page/__generated__/contentfulTypes';

const normalizeTestimonialsModuleContent = (content: PromoTemplateTestimonialCarouselFragment) => {
  const { headline, testimonialsCollection } = content;
  const items = testimonialsCollection?.items;

  if (!items || !items.length) return null;

  const testimonialItems: Array<React.ComponentProps<typeof TestimonialItem>> = items.filter(Boolean).map((item) => {
    const { author, testimonial, image } = item;
    return {
      name: author,
      quote: testimonial,
      imageSrc: image?.url,
    };
  });

  return {
    title: headline,
    testimonials: testimonialItems,
  };
};

export default normalizeTestimonialsModuleContent;
